import { guidelineList } from "./guidelines"

export const getGuidelineList = (includeQuicklinks = false) => {
    if (includeQuicklinks) {
        return guidelineList;
    } else {
        return guidelineList.filter(item => item.iconClassSuffix != 'quicklinks')
    }
}